<template>
  <footer class="site-footer">
    <!-- 桌面／平板版（≥721px 顯示） -->
    <div class="container footer-wrap">
      <!-- 左：標題 -->
      <div class="footer-left">
        <h3 class="footer-title">WEB3 項目速成課程（優越3.0）</h3>
        <div class="footer-sub">院長 G大</div>
      </div>

      <!-- 中：社群圖標 -->
      <nav class="footer-social" aria-label="社群連結">
        <!-- YouTube -->
        <a :href="youtubeUrl" target="_blank" rel="noopener" aria-label="YouTube" class="social-btn">
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M23.5 6.2a3.1 3.1 0 0 0-2.2-2.2C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.3.5A3.1 3.1 0 0 0 .5 6.2 32 32 0 0 0 0 12a32 32 0 0 0 .5 5.8 3.1 3.1 0 0 0 2.2 2.2c1.8.5 9.3.5 9.3.5s7.5 0 9.3-.5a3.1 3.1 0 0 0 2.2-2.2A32 32 0 0 0 24 12a32 32 0 0 0-.5-5.8ZM9.8 15.5V8.5l6.2 3.5-6.2 3.5Z" />
          </svg>
        </a>

        <!-- Discord -->
        <a :href="discordUrl" target="_blank" rel="noopener" aria-label="Discord" class="social-btn">
          <svg role="img" viewBox="-5 -5 35 35" xmlns="http://www.w3.org/2000/svg">
            <title>Discord</title>
            <path fill="#ffffff"
              d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
          </svg>
        </a>

        <!-- Threads -->
        <a :href="threadsUrl" target="_blank" rel="noopener" aria-label="Threads" class="social-btn">
          <img src="/images/threads-logo-white.svg" alt="Threads" class="icon-img" />
        </a>

        <!-- X -->
        <a :href="xUrl" target="_blank" rel="noopener" aria-label="X" class="social-btn">
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M18.2 2h3.1l-6.8 7.8L22 22h-6.8l-4.7-6.3L5 22H1.9l7.3-8.4L2 2h6.9l4.3 5.8L18.2 2Zm-1.2 18h1.7L7.1 4H5.3l11.7 16Z" />
          </svg>
        </a>
      </nav>

      <!-- 右：Discord 紫色按鈕 -->
      <a :href="discordUrl" target="_blank" rel="noopener" class="discord-cta" aria-label="前往 Discord">
        <span class="discord-icon">
          <svg role="img" viewBox="-5 -5 35 35" xmlns="http://www.w3.org/2000/svg">
            <title>Discord</title>
            <path fill="#5865F2"
              d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
          </svg>
        </span>
        <div class="discord-text">
          <div class="discord-title">進入 Discord 社群</div>
          <div class="discord-sub">Join our server</div>
        </div>
      </a>
    </div>

    <div class="container footer-copy">
      COPYRIGHT &nbsp; WEB3富翁區塊學院 &nbsp; ALL RIGHTS RESERVED.
    </div>

    <!-- 手機迷你版（≤720px 顯示） -->
    <div class="container footer-mini" aria-label="網站頁腳（手機）">
      <div class="fm-brand">WEB3 富翁區塊學院</div>

      <div class="fm-row">
        <!-- 左邊四個圓形社群 -->
        <nav class="fm-social" aria-label="社群連結（迷你）">
          <a :href="youtubeUrl" target="_blank" rel="noopener" aria-label="YouTube" class="fm-btn">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M23.5 6.2a3.1 3.1 0 0 0-2.2-2.2C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.3.5A3.1 3.1 0 0 0 .5 6.2 32 32 0 0 0 0 12a32 32 0 0 0 .5 5.8 3.1 3.1 0 0 0 2.2 2.2c1.8.5 9.3.5 9.3.5s7.5 0 9.3-.5a3.1 3.1 0 0 0 2.2-2.2A32 32 0 0 0 24 12a32 32 0 0 0-.5-5.8ZM9.8 15.5V8.5l6.2 3.5-6.2 3.5Z" />
            </svg>
          </a>
          <a :href="discordUrl" target="_blank" rel="noopener" aria-label="Discord" class="fm-btn">
            <svg role="img" viewBox="-5 -5 35 35" xmlns="http://www.w3.org/2000/svg">
              <title>Discord</title>
              <path fill="#ffffff"
                d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
            </svg> </a>
          <a :href="threadsUrl" target="_blank" rel="noopener" aria-label="Threads" class="fm-btn">
            <img src="/images/threads-logo-white.svg" class="fm-icon-img" alt="Threads">
          </a>
          <a :href="xUrl" target="_blank" rel="noopener" aria-label="X" class="fm-btn">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M18.2 2h3.1l-6.8 7.8L22 22h-6.8l-4.7-6.3L5 22H1.9l7.3-8.4L2 2h6.9l4.3 5.8L18.2 2Zm-1.2 18h1.7L7.1 4H5.3l11.7 16Z" />
            </svg>
          </a>
        </nav>

        <!-- 右邊紫色 Discord 社群 -->
        <a :href="discordUrl" target="_blank" rel="noopener" class="fm-cta-discord" aria-label="前往 Discord 社群">
          <svg role="img" viewBox="-5 -5 35 35" xmlns="http://www.w3.org/2000/svg">
            <title>Discord</title>
            <path fill="#ffffff"
              d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
          </svg>
          <span class="fm-cta-txt">加入 Discord</span>
        </a>
      </div>

      <div class="fm-copy">© WEB3 富翁區塊學院</div>
    </div>
  </footer>
</template>


<script setup>
const youtubeUrl = 'https://www.youtube.com/channel/UCIV2IDggNxi0pJKbkpVBEfQ'
const discordUrl = 'https://discord.gg/rdAVbdGzec'
const xUrl = 'https://x.com/crypto_gda'
const threadsUrl = 'https://www.threads.com/@web3school_gda'
</script>

<style scoped>
.site-footer {
  position: relative;
  z-index: 1;
  color: #fff;
  background: rgba(0, 0, 0, .55);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, .16);
}

/* ===== 桌面／平板版 ===== */
.footer-wrap {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 24px 0 6px;
}

.icon {
  width: 18px;
  height: 18px;
  fill: #fff
}

.icon-img {
  width: 21px;
  height: 21px;
  display: block;
  filter: brightness(1);
  transition: transform .2s ease
}

.social-btn:hover .icon-img {
  transform: scale(1.1);
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, .6))
}

.footer-left .footer-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: rgba(255, 255, 255, .37)
}

.footer-left .footer-sub {
  margin-top: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, .37)
}

.footer-social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px
}

.social-btn {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .14);
  transition: transform .15s ease, background .2s ease, border-color .2s ease;
}

.social-btn:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, .12);
  border-color: rgba(255, 255, 255, .28)
}

.discord-cta {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #5865F2;
  border: 1px solid rgba(255, 255, 255, .2);
  padding: 14px 20px;
  border-radius: 14px;
  text-decoration: none;
  color: #fff;
  transition: transform .15s, background .2s;
  box-shadow: 0 4px 12px rgba(88, 101, 242, .35);
  max-width: 280px;
}

.discord-cta:hover {
  background: #4752C4;
  transform: translateY(-1px)
}

.discord-icon {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: #fff;
  border-radius: 10px
}

.discord-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1
}

.discord-title {
  font-weight: 700;
  letter-spacing: .02em;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, .3)
}

.discord-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, .9)
}

.footer-copy {
  text-align: center;
  padding: 10px 0 20px;
  font-size: 13px;
  letter-spacing: .35em;
  color: rgba(255, 255, 255, .7)
}

/* ===== 手機迷你版（預設隱藏） ===== */
.footer-mini {
  display: none;
}

/* ===== 斷點：≤720px 啟用迷你版 ===== */
@media (max-width: 720px) {

  .footer-wrap,
  .footer-copy {
    display: none !important;
  }

  .footer-mini {
    display: block;
    padding: 12px 0 12px;
    text-align: center;
  }

  .fm-brand {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .04em;
    color: rgba(255, 255, 255, .9);
    margin-bottom: 8px;
  }

  /* 🔹 整行：左社群 + 右紫鈕 */
  .fm-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }

  /* 左邊四個圈圈 */
  .fm-social {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 0 0 auto;
  }

  .fm-btn {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background: rgba(255, 255, 255, .10);
    border: 1px solid rgba(255, 255, 255, .18);
    transition: transform .15s ease, background .2s ease, border-color .2s ease;
  }

  .fm-btn:active {
    transform: scale(.96);
  }

  .fm-icon {
    width: 18px;
    height: 18px;
    fill: #fff;
  }

  .fm-icon-img {
    width: 18px;
    height: 18px;
    display: block;
    filter: brightness(1);
  }

  /* 右邊紫色 Discord 鈕 */
  .fm-cta-discord {
  display: inline-flex;
  align-items: center;       /* ✅ 垂直置中圖示與文字 */
  justify-content: center;
  gap: 6px;
  padding: 9px 14px;
  background: #5865F2;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 13px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, .18);
  box-shadow: 0 4px 10px rgba(88, 101, 242, .35);
  transition: transform .15s ease, background .2s ease;
  flex-shrink: 0;
  line-height: 1;           /* ✅ 讓文字高度更緊貼居中 */
}

.fm-cta-discord:hover {
  background: #4752C4;
}
.fm-cta-discord:active {
  transform: scale(.98);
}

/* ✅ 微調 SVG 位置，讓圖示與字平齊 */
.fm-cta-discord svg {
  width: 18px;
  height: 18px;
  display: block;
  transform: translateY(1px);   /* 向下1px 微調對齊 */
}

  .fm-cta-ic {
    width: 18px;
    height: 18px;
    display: block;
  }

  .fm-copy {
    font-size: 11px;
    letter-spacing: .12em;
    color: rgba(255, 255, 255, .7);
  }
}
</style>
